import React, { FunctionComponent } from 'react';
import { useTranslation } from '@rbx/intl';
import { Grid, ArrowBackIcon, ArrowForwardIcon } from '@rbx/ui';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import useArticleNavigationSectionStyles from './ArticleNavigationSection.styles';

export interface ArticleNavigationSectionProps {
  next: string | null;
  prev: string | null;
}

const ArticleNavigationSection: FunctionComponent<
  React.PropsWithChildren<ArticleNavigationSectionProps>
> = ({ next, prev }) => {
  const { translate } = useTranslation();

  const {
    classes: { nextContainer, prevContainer, buttonContainer },
  } = useArticleNavigationSectionStyles();
  return (
    <Grid container className={buttonContainer}>
      {prev !== null && (
        <Grid className={prevContainer} item>
          <DynamicallyRouted.Button
            href={prev}
            variant='contained'
            size='large'
            startIcon={<ArrowBackIcon />}>
            {translate('Action.Previous')}
          </DynamicallyRouted.Button>
        </Grid>
      )}
      {next !== null && (
        <Grid className={nextContainer} item>
          <DynamicallyRouted.Button
            href={next}
            variant='contained'
            size='large'
            endIcon={<ArrowForwardIcon />}>
            {translate('Action.Next')}
          </DynamicallyRouted.Button>
        </Grid>
      )}
    </Grid>
  );
};

export default ArticleNavigationSection;
